import React, { Component } from 'react';
import { Route, Switch } from "react-router-dom";
import { Field, reduxForm } from 'redux-form'
import { Col, Row, Button } from 'reactstrap';
import { Preloading } from '../../../components/UI/Preloader/action';
import { connect } from 'react-redux';
import Modal from '../../../components/UI/Modal/Modal'
import { getCounterpartyType } from '../../../Analyst/Cases/Create/actions';
import {oneClickCorporateOnboarding} from '../Create/action';
import {DOMESTIC, INTERNATIONAL} from '../../../Analyst/Cases/constants'

const required = value => value ? null : 'Required';

const isValid = value => !value||value.match(/^[^<>!$%^?*~`{}=]*$/) ? null :'Please enter valid Input';

const renderField = ({ input, label, type, placeholder, isRequired, meta: { touched, error, warning } }) => {
    return (
        <Row className="mb-3 align-items-center">
            <Col sm="9">
                <label className="mb-0">{label}</label>
                {(isRequired && <span className="text-danger">*</span>)}
            </Col>
            
            <Col sm="15">
                <input {...input} placeholder={placeholder} type={type} className = "form-control"/> 
                {touched &&
                    ((error && <span className="text-danger">{error}</span>) ||
                        (warning && <span className="text-warning">{warning}</span>))}
            </Col>
        </Row>
    );
}

class OneClickCorparateOnBoarding extends Component {
    constructor(props) {
        super(props);
        this.state = {
                      resizeZIndex: false,
                      showModal: false,
                    }

    }

    getInitialModalState = () => ({
        body: <form className="modal-content shadow-none border-0" onSubmit={(e) => this.handleOnboardFormSubmit(e)}><br/>
            <Field
                name="companyName"
                type="text"
                component={renderField}
                label="Company Name"
                isRequired={true}
                validate={[required,isValid]}
                placeholder = "Company Name" />

            <Field
                name="gstNo"
                type="text"
                component={renderField}
                label="Company GST No."
                isRequired={true}
                validate={[required,isValid]}
                placeholder = "22-AAAA0000A-1Z5"/>

                <div>
                    <label>Product Geography&nbsp;<span className="text-danger">*</span></label>
                    <div>
                        <label>
                            <Field name="productGeography" component="input" type="radio" value={DOMESTIC} validate={[required]}/>{' '}
                            Domestic
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <label>
                            <Field name="productGeography" component="input" type="radio" value={INTERNATIONAL}  validate={[required]}/>{' '}
                            International
                         </label>
                    </div>
                    &nbsp;
                </div>

                <label>Counterparty Type&nbsp;<span className="text-danger">*</span></label>
                <Field name="counterpartyType" component="select" className="form-control dropdown-counterparty border" validate={[required]}>
                    <option value=''>Select</option>
                    {
                        this.props.counterPartyTypeDropdown.map(p => {
                            return (
                                <option key={p} value={p}>{p}</option>
                            )
                        })
                    }
                </Field>
                <br/>
                <Button type="submit" color="primary" >Submit</Button>
        </form>
    })

    componentDidMount() {
        this.setState(this.getInitialModalState())
        this.props.fetchCounterPartyType();
    }

    componentDidUpdate(prevProps) {
        if(this.props.showOnboardModal !== prevProps.showOnboardModal) {
            this.setState(prevState => ({showModal: !prevState.showModal}))
            this.setState(this.getInitialModalState())
            this.props.reset()
        }
        if (!this.props.result.error && this.props.result !== prevProps.result) {
            this.setState({ resizeZIndex: false })
            this.props.preloading(false)
            this.setState({
                body: <div className="modal-body">
                    <h5 className="text-success"><i className="fa fa-check-circle"></i>&nbsp;Success</h5>
                    <h5>Corporate oboarded successfully with <i>{this.props.result.data}</i> corporate ID</h5><br/>
                    <Button color="info" onClick={this.handleViewCorporate}>View</Button>
                </div>
            })

        }
        else if (this.props.result.error && this.props.result !== prevProps.result) {
            this.setState({ resizeZIndex: false })
            this.props.preloading(false)
            this.setState({
                body: <div className="modal-body">
                    <h5 className="text-danger"><i className="fa fa-exclamation-triangle">&nbsp;</i>Failure</h5>
                    <h5>Failure in Corporate Oboarding!</h5>
                    <h5>{(this.props.result.error.response && this.props.result.error.response.data) ? this.props.result.error.response.data.message : "Something went wrong! Please try again."}</h5><br/>
                    <Button color="info" onClick={this.handleOk}>OK</Button>
                </div>
            })
        }
    }

    handleViewCorporate = () => {
        this.props.history.push(`/corporate/onboarding/edit/${this.props.result.data}/companysetup`)
    }

    handleOnboardFormSubmit = (event) => {
        event.preventDefault()
        let formValues = {
            companyName: event.target.elements.companyName.value,
            gstNo: event.target.elements.gstNo.value,
            productGeography: event.target.elements.productGeography.value,
            counterpartyType: event.target.elements.counterpartyType.value
        }
        this.props.oneClickCorporateOnboarding(formValues)
        this.props.preloading(true)
        this.setState({ resizeZIndex: true })

    }

    handleOk = () => {
        this.setState(this.getInitialModalState())
    }

    handleCancel = () => {
        this.props.closeModal()      
    }


    render() {
            let modalHeader = <div className="modal-header row pt-0">
            <h5 className="mb-0">Onboard Corporate</h5>
            <button type="button" onClick={this.handleCancel} className="close outline-none" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>;
        return (
            <Modal show={this.state.showModal} className={this.state.resizeZIndex ? 'z-index-zero Large-Modal modal-content' : 'Large-Modal modal-content'} modalClosed={this.handleModal} >
                    {modalHeader}
                    {this.state.body}
                </Modal>
        )
    }
}
const mapStateToProps = (state) => ({
    counterPartyTypeDropdown: state.createCase.dropdownData,
    result: state.corporateOnBoardingCreate.result
});

const mapDispatchToProps = (dispatch) => ({
    oneClickCorporateOnboarding : (data) => dispatch(oneClickCorporateOnboarding(data)),
    fetchCounterPartyType: () => dispatch(getCounterpartyType()),
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default reduxForm({
    form: 'OneClickCorporateOnboardForm'
})(connect(mapStateToProps, mapDispatchToProps)(OneClickCorparateOnBoarding))